import { useContext, useEffect, useState } from 'react'

import { ReactCountdownStyled } from './ReactCountdown.styled'
import { ReactCountdownClockProps } from './types'
import ReactText from '../ReactText'
import { Accordion, AccordionContext } from '../shared/ReactBootstrap'

const ReactCountdown = (props: ReactCountdownClockProps): JSX.Element => {
  const {
    isInEditor,
    comingSoonText = '',
    preOrderText = '',
    daysText,
    hoursText,
    minutesText,
    secondsText,
    accordionMobileIcon,
    countdownTarget = '',
    childComponents
  } = props

  // Use Eastern Daylight Savings Time as the countdown target
  const countdownTime = countdownTarget.split(':')
  const theHour: any = countdownTime[0]
  const theMonth: any = countdownTime[1]
  const theDay: any = countdownTime[2]
  const theYear: any = countdownTime[3]

  const dayUnit = 86400000
  const hrUnit = 3600000
  const minUnit = 60000
  const secUnit = 1000

  const [countdown, setCountdown] = useState({
    text: comingSoonText,
    remainingDays: '00',
    remainingHours: '00',
    remainingMins: '00',
    remainingSecs: '00',
    displayTimer: false,
    countdownEnded: false
  })

  const countdownEnded = () => {
    setCountdown({ ...countdown, text: preOrderText, displayTimer: true, countdownEnded: true })
  }

  useEffect(() => {
    const offset = new Date().getTimezoneOffset()
    const hrOffset = offset / 60 - 4
    const minOffset = offset % 60
    const targetDate = new Date(theYear, theMonth - 1, theDay, theHour - hrOffset, 0 - minOffset, 0).getTime()

    if (targetDate - new Date().getTime() < 1000) {
      countdownEnded()
    }
    const targetTime = setInterval(() => {
      const currDate = new Date().getTime()
      let diff = targetDate - currDate
      if (diff < 1000) {
        countdownEnded()
        clearInterval(targetTime)
      } else {
        const remDays = String(Math.floor(diff / dayUnit)).padStart(2, '0')
        diff = diff % dayUnit
        const remHrs = String(Math.floor(diff / hrUnit)).padStart(2, '0')
        diff = diff % hrUnit
        const remMins = String(Math.floor(diff / minUnit)).padStart(2, '0')
        diff = diff % minUnit
        const remSecs = String(Math.floor(diff / secUnit)).padStart(2, '0')
        setCountdown({
          ...countdown,
          remainingDays: remDays,
          remainingHours: remHrs,
          remainingMins: remMins,
          remainingSecs: remSecs,
          displayTimer: true
        })
      }
    }, 500)
    return () => clearInterval(targetTime)
  }, [])

  const { activeEventKey } = useContext(AccordionContext)
  const handleAccordionClick = (event: any, eventKey: string) => {
    let linkName = ''
    activeEventKey === eventKey ? (linkName = 'close') : (linkName = 'open')

    window.utag = window?.utag || {}
    window?.utag?.link({
      eventNames: 'autotrack',
      _linkObject: `${event?.currentTarget?.parentNode?.childNodes}`,
      linkUrl: 'arrow-toggle-' + linkName,
      linkNavSection: '',
      linkName: 'countdown',
      pageName: window?.utag_data?.pageName
    })
  }

  const displayEditorSection = (section: JSX.Element, index: number) => {
    const { isInEditor, id } = props
    const editorText = [
      'Edit Hero Contents to be displayed during Countdown',
      'Edit Hero Contents to be displayed after Countdown Ended'
    ]
    return (
      <div key={'section-' + index} id={id}>
        {isInEditor && <div className='editor-text'>{editorText[index]}</div>}
        {section}
      </div>
    )
  }

  return (
    <>
      <Accordion.Header
        as={'div'}
        onClick={(event) => {
          handleAccordionClick(event, '0')
        }}
      >
        <ReactCountdownStyled className='accordion-chevron-desktop' {...props}>
          <div className='countdown-header'>
            <ReactText text={countdown.text} className='cox-text-heading3 countdown-text' />
            {countdown.displayTimer && (
              <div className='timer'>
                {countdown.remainingDays !== '00' && (
                  <>
                    <div className='days'>
                      <div className='label'>{daysText}</div>
                      <div>{countdown.remainingDays}</div>
                    </div>
                    <div className='colon'>:</div>
                  </>
                )}
                <div className='hours'>
                  <div className='label'>{hoursText}</div>
                  <div>{countdown.remainingHours}</div>
                </div>
                <div className='colon'>:</div>
                <div className='minutes'>
                  <div className='label'>{minutesText}</div>
                  <div>{countdown.remainingMins}</div>
                </div>
                {countdown.remainingDays === '00' && (
                  <>
                    <div className='colon'>:</div>
                    <div className='seconds'>
                      <div className='label'>{secondsText}</div>
                      <div>{countdown.remainingSecs}</div>
                    </div>
                  </>
                )}
              </div>
            )}
            <div
              className='accordion-chevron d-md-none'
              style={{ background: `url("${accordionMobileIcon}") center no-repeat` }}
            ></div>
          </div>
        </ReactCountdownStyled>
      </Accordion.Header>

      <Accordion.Body>
        {isInEditor &&
          childComponents.map((childComponent: any, index: number) => displayEditorSection(childComponent, index))}
        {!isInEditor && !countdown.countdownEnded && childComponents[0]}
        {!isInEditor && countdown.countdownEnded && childComponents[1]}
      </Accordion.Body>
    </>
  )
}

export default ReactCountdown
